import { defineStore } from 'pinia'

const STORAGE_KEY = 'ck-op-theme'

export const useThemeStore = defineStore('theme', {
  state: () => ({ theme: (localStorage.getItem(STORAGE_KEY) as 'dark' | 'light' | null) ?? 'dark' }),
  actions: {
    apply() {
      document.documentElement.setAttribute('data-theme', this.theme)
    },
    toggle() {
      this.theme = this.theme === 'dark' ? 'light' : 'dark'
      localStorage.setItem(STORAGE_KEY, this.theme)
      this.apply()
    }
  }
})
